import { FC } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { ViewType } from "../../../page/enums/ViewType";
import { NoDataIcon } from "./rowIcons";
import { useTheme } from "../../../features/context/CustomerContext";
import useCustomTranslation from "../../../features/hooks/CustomUseTranslation";

const NoDataWrapper = styled.div`
    @media screen and (min-width: ${props => props.theme.mobileTableBreakPoint}px) {
        width: 320px;
        margin: auto;
        position: relative;
    }
    @media screen and (max-width: ${props => props.theme.mobileTableBreakPoint}px) {
        text-align: center;
    }
`
const NoDataText = styled.p`
    padding: 5px;
    @media screen and (min-width: ${props => props.theme.mobileTableBreakPoint}px) {
        width: 390px;
    }
    @media screen and (max-width: ${props => props.theme.mobileTableBreakPoint}px) {
        font-size: 12px;
    }
`
const ClickHere = styled.a`
    color: ${props => props.theme.brandColor1};
    cursor: pointer;
    font-weight: 700;
    text-decoration: underline;
`
export interface TableNoDataInfoProps {
    type: ViewType;
}

const TableNoDataInfo: FC<TableNoDataInfoProps> = (props) => {
    const { t } = useCustomTranslation();
    const history = useHistory();
    const theme = useTheme();

    return (
        <NoDataWrapper theme={theme}>
            <NoDataIcon theme={theme} />
            {props.type === ViewType.SENT_APPLICATIONS ?
                <>
                    <NoDataText theme={theme}>{t("NoSentApplicationsFirst")}</NoDataText>
                    <NoDataText theme={theme}>{t("NoSentApplicationsSecond")}
                        <ClickHere theme={theme} onClick={() => { history.push('selectApplicationType') }}>{t("clickHere")}.</ClickHere>
                    </NoDataText>
                </> :
                props.type === ViewType.AUTHORIZED_USERS ?
                    <NoDataText theme={theme}>{t("NoAuthorizedUsers")}</NoDataText> :
                    <>
                        <NoDataText theme={theme}>{t("NoCustomersOrAuthorizedUsersFirst")}</NoDataText>
                        <NoDataText theme={theme}>{t("NoCustomersOrAuthorizedUsersSecond")}</NoDataText>
                    </>}
        </NoDataWrapper>
    )
}

export default TableNoDataInfo;